
    /** @jsxImportSource react */
    import useIcon, { IconProps } from '../hooks/useIcon';

    export default (props : IconProps) => {
      const svgProps = useIcon(props);
      return (
        <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" {...svgProps}>
  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  <circle cx="9" cy="7" r="4"/>
</svg>
      );
    };